import { getLaunchDarklyClientId, getEnvName } from '../../constants/environment';

/**
 * LaunchDarkly Configuration Module
 * 
 * Provides environment-specific configuration for LaunchDarkly integration.
 * Automatically detects the current environment and provides appropriate client ID.
 */

// Environment-specific LaunchDarkly client-side ID
export const LAUNCHDARKLY_CLIENT_SIDE_ID = getLaunchDarklyClientId();

/**
 * Creates default anonymous user configuration for LaunchDarkly
 * Used when no authenticated user context is available
 */
export const getDefaultUser = () => ({
  key: 'anonymous-user',
  anonymous: true,
  custom: {
    environment: getEnvName(),
    application: 'condo-ui',
    hostname: window.location.hostname,
    timestamp: Date.now()
  }
});

/**
 * Creates authenticated user configuration for LaunchDarkly targeting
 * @param {string} userId - Unique user identifier
 * @param {object} userAttributes - Additional user attributes for targeting
 * @returns {object} LaunchDarkly user configuration
 */
export const createUser = (userId, userAttributes = {}) => ({
  key: userId,
  anonymous: false,
  ...userAttributes,
  custom: {
    environment: getEnvName(),
    application: 'condo-ui',
    hostname: window.location.hostname,
    authenticatedAt: Date.now(),
    ...userAttributes.custom
  }
});
